import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { TitleStrategy } from '@angular/router';
import { PORTAL_DISPLAY_NAME } from './portal-display-name.token';
import { PortalTitleStrategy } from './portal-title.strategy';

/**
 * Registers portal display name + TitleStrategy for `{page} | {portalName}` tab titles.
 */
export function providePortalTitle(portalName: string): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: PORTAL_DISPLAY_NAME, useValue: portalName },
    { provide: TitleStrategy, useClass: PortalTitleStrategy }
  ]);
}
